module.exports = __webpack_public_path__ + "static/media/next-icon-call-for-payment-o.bbb15927.svg";